// Environments
/* AWS Environment */
export const URL_ENV: string = window.location.hostname.split(".")[0] || "dev2";
export const ENV: string = (URL_ENV === "localhost") ? "dev2" : (URL_ENV === "app") ? "prod" : URL_ENV;
// Colors
export const ERROR_MESSAGE_COLOR_DEFAULT: string = "#181c32";
export const ERROR_MESSAGE_COLOR_RED: string = "#f1416c";
